<template>
  <div class="mapWrapper">
    <div id="currentZoomDev" v-if="isDevEnviroment">
      {{ currentZoom }}
    </div>
    <mapbox
      :access-token="appSettings.map.accessToken"
      :map-options="{ ...options, ...appSettings.map.options }"
      @map-load="loaded"
      @map-init="initialized"
      :nav-control="{
        show: true,
        position: 'top-left'
      }"
      :geolocate-control="{
        show: true,
        position: 'top-left',
        options: {
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true,
          showUserHeading: true
        }
      }"
      :scale-control="{
        show: false,
        position: 'top-left'
      }"
      :fullscreen-control="{
        show: true,
        position: 'top-left'
      }"
    />
  </div>
</template>

<script>
//cluster ajsdflj https://docs.mapbox.com/mapbox-gl-js/example/cluster-html/

import { mapState } from "vuex";
import { eventBus } from "../../main";

import Mapbox from "mapbox-gl-vue";
//import mapboxgl from "mapbox-gl";
import genericMapServices from "./services/genericMapServices.js";

import markerService from "./services/markerService.js";
import artworkAssetService from "./services/artworkAssetService.js";

import signageMarkerLayerService from "./services/signageMarkerLayerService.js";
import circleSignageMarkerLayerService from "./services/circleSignageMarkerLayerService.js";

//import animationService from "./services/animationService.js";
//import geoJsonLineGeomService from "./services/geom/geoJsonLineGeomService.js";
import tempGeoJsonLineGeomService from "./services/geom/tempGeoJsonLineGeomService.js";
import customArrowWorkflow from "./services/customArrowWorkflow.js";

import mapEventsService from "./services/mapEventsService.js";

import layerFilterMixin from "./mixins/layer-filter-mixin";
import markerMenuMixin from "./mixins/marker-menu-mixin";
import markerEffectsMixin from "./mixins/marker-effects-mixin";
import tooltipMixin from "./mixins/tooltip-mixin";
import mediaEventsMixin from "./mixins/media-events-mixin";

export default {
  components: { Mapbox },
  mixins: [
    layerFilterMixin,
    markerMenuMixin,
    markerEffectsMixin,
    tooltipMixin,
    mediaEventsMixin
  ],
  name: "Map",
  computed: {
    ...mapState({
      isDevEnviroment: state => state.navigation.isDevEnviroment,

      //global:
      appSettings: state => state.global.appSettings,
      markerSections: state => state.markers.sections,
      geoJson_artwork: state => state.markers.geoJson_artwork,
      geoJson_signage: state => state.markers.geoJson_signage,
      categoryLookup: state => state.markers.categoryLookup,
      markerImages: state => state.markers.markerImages,
      playingSiteName: state => state.media.playingSiteName,
      currentTrack: state => state.media.currentTrack,
      isPlaying: state => state.media.isPlaying,

      //markers:
      stackedMarkers: state => state.markers.stackedMarkers,
      markerList: state => state.markers.markerList,

      //sites:
      baseurllocation: state => state.navigation.baseurllocation,
      layers: state => state.filters.layers
    }),
    sites() {
      this.$store.dispatch("navUpdateSiteList", this.markerList.data.features);
      return this.markerList.data.features;
    }
  },

  props: {
    drawer: Boolean
  },
  data: () => ({
    currentZoom: 0,
    lastMarkerSize: null,
    toolTipAct: null,
    useCluster: false,
    useCircles: true,
    popups: [],
    map: null,
    options: {
      container: "mapContainer",
      projection: "mercator" //equalEarth, globe, naturalEarth, mercator
    },

    pointLayerIds: {},
    hoverStatePointLayerIds: {},
    tooltipPointLayerIds: {},
    mobileClickTooltipPointLayerIds: {},
    geomClickLoadPopup: {},
    dataSouceIds: {},
    filterableDataSouceIds: {},
    comboIconDataSoucesIds: {},
    clusterLayersWithNoClick: {}
  }),
  mounted() {},
  created() {
    eventBus.$on("nav_exitFullScreen", () => {
      this.exitFullScreen();
    });

    eventBus.$on("nav_map_reset", () => {
      this.resetMap();
    });

    eventBus.$on("flyToPoint", (layer, site) => {
      this.flyToPoint(layer, site);
    });

    eventBus.$on("nav_map_flyToLongLat", coordinates => {
      this.clearAllPopups();

      this.updatePaddingZoomForRemotePopup(coordinates, true);
      if (this.$vuetify.breakpoint.mdAndDown) {
        eventBus.$emit("nav_layout_closeMenu");
      }
    });
    eventBus.$on("nav_map_flyToFeature", feature => {
      this.clearAllPopupsBasic();

      let coordinates = feature?.geometry?.coordinates;

      if (coordinates) {
        this.updatePaddingZoomForRemotePopup(coordinates, true);
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        eventBus.$emit("nav_layout_closeMenu");
      }

      let openToolTip = () => {
        let event = {
          features: [feature]
        };

        this.createTooltip(event);
      };

      setTimeout(() => {
        openToolTip();
      }, 1000);
    });

    eventBus.$on("nav_map_flyToOpenPopUpByName", pointName => {
      this.goToPointByPointName(pointName);
    });

    eventBus.$on("nav_map_flyToOpenPopUp", index => {
      this.createPopupFromIndex(index);
      if (this.$vuetify.breakpoint.mdAndDown) {
        eventBus.$emit("nav_layout_closeMenu");
      }
    });
  },
  watch: {
    layers: function(filters) {
      this.updatefilters(filters);
      this.clearAllPopups();
    }
  },
  methods: {
    resetMap(firstLoad) {
      let {
        pitch,
        center,
        bearing,
        zoom,
        zoomMob,
        zoomTab
      } = this.appSettings.map.defaultSetup;

      if (this.$vuetify.breakpoint.mobile) {
        if (zoomMob) {
          zoom = zoomMob;
        }
      } else if (this.$vuetify.breakpoint.smAndDown) {
        if (zoomTab) {
          zoom = zoomTab;
        }
      }

      if (firstLoad) {
        if (this.appSettings.map.bounds) {
          this.map.setMaxBounds(this.appSettings.map.bounds);
        }
      } else {
        window.mvAnalyticEvent("ui", "resetPressed", "resetPressed", false);
        this.$store.dispatch("filters_resetLayers");
        eventBus.$emit("remote-ui-layercontrol-close");
        eventBus.$emit("remote-ui-legned-close");
        this.clearAllPopups();
        this.$store.dispatch("navUpdateSidebarSite", false);
        this.$store.dispatch("navUpdateFocusSite", false);
        eventBus.$emit("nav_siteList_scrollToTop");

        //this.map.setZoom(zoom);
        //this.map.setPitch(pitch);
        //this.map.setBearing(bearing);
        //this.map.setCenter(center);

        /*

*/
      }

      if (this.appSettings.map.flyToBounds) {
        let options = { bearing, pitch };
        if (this.drawer === true) {
          options.padding = { top: 0, bottom: 0, left: 0, right: 430 };
        }

        this.map.fitBounds(this.appSettings.map.flyToBounds, options);
      } else if (this.appSettings.map.defaultSetup) {
        this.map.flyTo({ pitch, center, bearing, zoom });
      }
    },
    flyToPoint(layer, site) {
      this.updatePaddingZoomForRemotePopup(site?.geometry?.coordinates, true);

      if (layer == "markerList") {
        this.createPopupFromIndex(site?.properties?.index);
      }
    },
    exitFullScreen() {
      //if fullscreen mode go back to normal
      try {
        let [FullscreenControl] = this.map._controls.filter(
          value => value.constructor.name == "FullscreenControl"
        );
        if (FullscreenControl._fullscreen === true) {
          FullscreenControl._onClickFullscreen();
        }
      } catch (error) {
        //do nothing
      }
    },
    openSidebar(index) {
      this.exitFullScreen();

      eventBus.$emit("nav_layout_openMenu");
      eventBus.$emit("nav_sideBar_openMoreInfo");
      this.$store.dispatch("navUpdateSidebarSite", index);
    },
    updatePaddingZoomForRemotePopup(coordinates, flyTo) {
      if (window.outerHeight < 700 || this.$vuetify.breakpoint.mobile) {
        //setting padding so info window canload up ;
        this.map.setPadding({ top: (window.outerHeight - 80) / 2 });
      } else {
        this.map.setPadding({ top: 0 });
      }

      if (flyTo) {
        let options = {
          speed: this.useCluster ? 0.5 : 1,
          center: coordinates,
          zoom:
            this.map.getZoom() < this.appSettings.zoomToOnSelect
              ? this.appSettings.zoomToOnSelect + 0.5
              : this.map.getZoom()
        };
        this.map.flyTo(options);
      }
    },

    goToPointByPointName(pointName) {
      let [point] = this.sites.filter(row => {
        return row.properties.Point_Name == pointName;
      });

      if (point && point.properties && point.properties.index) {
        this.loadMarkerByIdFromMenu(point.properties.index);
      }
    },

    loadMarkerByIdFromMenu(index) {
      this.clearAllPopups();

      try {
        let properties = this.sites[index].properties;
        let coordinates = this.sites[index].geometry.coordinates;

        this.createNormalPopup(coordinates, properties);

        //if (this.map.getZoom() < 18) {

        this.updatePaddingZoomForRemotePopup(coordinates, true);
        //}
      } catch (error) {
        //do nothing;
      }
    },

    getParameterByName(name, url = window.location.href) {
      name = name.replace(/[[]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    } /*
    updatePath(properties) {

      let newId = properties.Site_Marker_Number;
      //let oldId = this.$route;
      //if (newId && newId !== oldId) {
      if (newId) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          `?id=${newId}`;

        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
*/,
    initialized(/*map*/) {},

    async loaded(map) {
      //const layers = map.getStyle().layers;
      // Find the index of the first symbol layer in the map style.
      //for (const layer of layers) {
      //if (layer.type === "symbol") {
      //break;
      //}
      //}

      window.clearAllPopups = this.clearAllPopups.bind(this);
      map._isVue = true;
      this.map = map;
      window.thismap = map;

      if (this.appSettings.map.disableRotationAndBearing) {
        // disable map rotation using right click + drag
        this.map.dragRotate.disable();
        // disable map rotation using touch rotation gesture
        this.map.touchZoomRotate.disableRotation();
      }

      this.resetMap(true);

      /*
          maxBounds:
*/

      setTimeout(() => {
        customArrowWorkflow.addLayers({
          parentThis: this,
          map: this.map,
          appSettings: this.appSettings
        });

        var clickableDiv = document.querySelector(".mapboxgl-ctrl-geolocate");

        // Step 2: Attach a click event listener to the element
        clickableDiv.addEventListener("click", function() {
          window.mvAnalyticEvent("ui", "geolocateClicked", "map");
        });
      }, 1000);

      if (tempGeoJsonLineGeomService && !this) {
        tempGeoJsonLineGeomService.addLayers({
          parentThis: this,
          map: this.map,
          appSettings: this.appSettings
        });
      }
      /*
      geoJsonLineGeomService.addLayers({
        parentThis: this,
        map: this.map,
        appSettings: this.appSettings
      });
*/
      try {
        this.currentZoom = map.getZoom();
        this.currentZoom = Math.round(this.currentZoom * 100) / 100;
      } catch (error) {
        //do nothing;
      }

      map.on("moveend", () => {
        try {
          this.currentZoom = map.getZoom();
          this.currentZoom = Math.round(this.currentZoom * 100) / 100;
        } catch (error) {
          //do nothing;
        }
      });

      /*
      if (this === false) {
        animationService.drawPlane({
          parentThis: this,
          map: this.map,
          appSettings: this.appSettings
        });
      }

      if (this === false) {
        animationService.drawBoat({
          parentThis: this,
          map: this.map,
          appSettings: this.appSettings
        });
      }
*/

      genericMapServices.initFalseImageObj(this.map);

      let loadartwork = true;

      if (loadartwork) {
        artworkAssetService.addArtWorkLayer({
          parentThis: this,
          map: this.map,
          geoJson_artwork: this.geoJson_artwork,
          categoryLookup: this.categoryLookup,
          appSettings: this.appSettings
        });
      }

      await markerService.createWpmarkerImages(
        this.map,
        this.markerImages,
        this.categoryLookup,
        this.appSettings.markerImageAssetOrderPriority
      );

      await signageMarkerLayerService.createSignageLayer({
        parentThis: this,
        map: this.map,
        layerIdName: "signage",
        geoJson: this.geoJson_signage,
        appSettings: this.appSettings,
        markerSections: this.markerSections
      });

      await (this.appSettings?.layerDefaults?.places?.useCircle
        ? circleSignageMarkerLayerService
        : signageMarkerLayerService
      ).createSignageLayer({
        parentThis: this,
        map: this.map,
        layerIdName: "places",
        geoJson: this.markerList,
        appSettings: this.appSettings,
        markerSections: this.markerSections
      });

      mapEventsService.addEvents({
        parentThis: this,
        map: this.map,
        appSettings: this.appSettings,
        mapboxgl: window.mapboxgl,
        markerImages: this.markerImages
      });

      setTimeout(() => {
        //this is to load points from query tring on load; ;
        let queryStringSiteNumber = this.getParameterByName("id");
        let validTargets = this.sites.filter(
          point => point.properties.Site_Marker_Number === queryStringSiteNumber
        );

        if (validTargets[0]) {
          try {
            let coordinates = validTargets[0].geometry.coordinates.slice();
            let properties = validTargets[0].properties;

            if (coordinates && properties?.Site_Marker_Number) {
              //window.gtag("event", "intalTo_" + properties.Site_Marker_Number);
              window.mvAnalyticEvent(
                "load",
                "intalTo",
                properties.Site_Marker_Number,
                false
              );

              this.createPopup(coordinates, properties, false);
              this.$store.dispatch("navUpdateSidebarSite", properties.index);

              this.map.flyTo({
                zoom: this?.appSettings?.zoomToOnSelect
                  ? this.appSettings.zoomToOnSelect
                  : 16,
                center: coordinates
              });
            }
          } catch (error) {
            //do nothing
          }
        }

        this.updatefilters(this.layers);
      }, 300);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.container > div > .mapWrapperWrapper {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100vw;
  max-width: 100vw !important;
  border: none;
}

#mapContainer {
  height: 100%;
  width: 100vw;
  padding: 0;
  margin: 0;
}

#currentZoomDev {
  height: 28px;
  width: 54px;
  overflow: visible;
  z-index: 2;
  top: 183px;
  left: 10px;
  position: absolute;
  background: white;
  border: 2px solid #ff000052;
  border-radius: 5px;
  text-align: center;
  font-size: 17px;
}
</style>
